import { useState } from "react";
import TableAccordion from "./TableAccordion";
import { Column, Row } from "react-table";
import { TRStyle, TRStyleContent } from "./styles";
import useAcordo from "core/features/acordo/hooks/useAcordo";
import { IoMdArrowDown } from "react-icons/io";

interface AccordionTableRowProps {
  index: number;
  dataAcordo?: any;
  columns?: Column[] | any;
  columnsInnerTable: Column[];
  onClick?: (e: any) => void;
  row: Row<object>;
  onClickRow?: (index: number) => void;
}

const AccordionTableRow = ({
  index,
  dataAcordo,
  row,
  onClickRow,
  columnsInnerTable,
}: AccordionTableRowProps) => {
  const { data } = useAcordo(dataAcordo.id);

  const [expanded, setExpanded] = useState(false);
  const handleToggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <TRStyle
        {...row.getRowProps()}
        onClick={handleToggleExpanded}
        isOpen={expanded}
        rows={row?.cells?.length}
      >
        {row.cells.map((cell) => {
          const cellProps = { ...cell.getCellProps() };

          const col: any = cell.column;

          let onClick: any = undefined;

          if (!col.disableClick) {
            if (typeof col.onClick === "function") {
              onClick = col.onClick;
            } else if (typeof onClickRow === "function") {
              onClick = onClickRow;
            }
          }

          const isClicked = typeof onClick === "function";

          return (
            <td
              onClick={() => {
                if (isClicked) {
                  onClick(index);
                }
              }}
              {...cellProps}
              style={{
                cursor: "pointer",
                textAlign: "center",
              }}
            >
              {cell.render("Cell")}
            </td>
          );
        })}

        <IoMdArrowDown />
      </TRStyle>

      {expanded && (
        <TRStyleContent isOpen={expanded}>
          <td colSpan={6}>
            <div>
              <TableAccordion
                data={data ? data : []}
                columns={columnsInnerTable}
              />
            </div>
          </td>
        </TRStyleContent>
      )}
    </>
  );
};

export default AccordionTableRow;
